import { render, staticRenderFns } from "./QtdConsolidado.vue?vue&type=template&id=5fcf7b61&"
import script from "./QtdConsolidado.vue?vue&type=script&lang=js&"
export * from "./QtdConsolidado.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports